import React, { FC } from 'react';

interface ILoader {
  className?: string;
}

const Loader: FC<ILoader> = ({ className }) => {
  return (
    <div className={`loader ${className || ''}`}>
      <img src="/images/loader.svg" alt="loader" />
    </div>
  );
};
export default Loader;
